/**
 * Display-only requester label from ticket API fields.
 * Placeholder names (e.g. "Customer", "Guest") yield requesterEmail when present.
 *
 * @param {{ requesterFullName?: string|null, requesterEmail?: string|null }} ticket
 * @returns {string}
 */
export function formatRequesterDisplay({ requesterFullName, requesterEmail } = {}) {
  const name = (requesterFullName || '').trim();
  const email = (requesterEmail || '').trim();
  const isPlaceholder = !name || ['customer', 'guest'].includes(name.toLowerCase());
  if (!isPlaceholder) return name;
  if (email) return email;
  return name || email;
}
